import { apiClient } from "./client";
import type { LoginRequest, CreateMemberRequest, Login200Response } from "../types/swagger";

export type { LoginRequest, CreateMemberRequest, Login200Response };

const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";

const mockAdminLoginResponse: Login200Response = {
  access_token: "mock-jwt-token-admin",
  admin_flg: true,
};

const mockUserLoginResponse: Login200Response = {
  access_token: "mock-jwt-token-user",
  admin_flg: false,
};

export const authApi = {
  /** ログイン */
  login: async (body: LoginRequest): Promise<Login200Response> => {
    // Service Worker が使えない環境でも、モック有効時は確実にログインできるようにする。
    if (USE_MOCK) {
      return body.login_id === "admin"
        ? mockAdminLoginResponse
        : mockUserLoginResponse;
    }
    const { data } = await apiClient.post<Login200Response>("/login", body);
    return data;
  },

  /** アカウント作成 */
  signUp: async (body: CreateMemberRequest): Promise<void> => {
    if (USE_MOCK) return;
    await apiClient.post("/member", body);
  },

  /** ログアウト */
  logout: async (): Promise<void> => {
    if (!USE_MOCK) {
      await apiClient.post("/logout");
    }
    localStorage.removeItem("token");
    localStorage.removeItem("isAdmin");
  },
};
